export const DEFAULT_ENVIRONMENT_ID = 'defaultEnvironmentId';
export const LAST_VIEWED_RELEASE_DATE = 'lastViewedReleaseDate';
